import * as Log from "web-ui/log"

export function InputInstructionsPlugin(options) {
  const tomSelect = this

  if (!options.instructions) {
    return
  }

  const instructions = document.createElement("p")
  instructions.classList.add("control-instructions")
  instructions.innerText = options.instructions

  instructions.style.display = "none"

  tomSelect.hook("before", "setup", () => {
    const control = tomSelect.control
    control.appendChild(instructions)
  })

  tomSelect.on("dropdown_open", () => {
    if (Object.keys(tomSelect.options).length === 0) {
      instructions.style.display = "none"
    } else {
      instructions.style.display = "block"
    }
  })

  tomSelect.on("option_remove", () => {
    if (Object.keys(tomSelect.options).length === 0) {
      instructions.style.display = "none"
    }
  })

  tomSelect.on("dropdown_close", () => {
    instructions.style.display = "none"
  })

  tomSelect.on("type", () => {
    if (tomSelect.currentResults.total) {
      instructions.style.display = "block"
    } else {
      instructions.style.display = "none"
    }
  })
}

